import { API_URL } from "../api/url";

export const BASE_URL = process.env.REACT_APP_API_URL || API_URL?.API_BASE_URL+ '/api/v1';

export const APP_NAME = 'AstroPandit Staff';

export const ROLES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  SUPPORT: 'support',
  FINANCE: 'finance',
  CONTENT: 'content',
};

export const PERMISSIONS = {
  super_admin: [
    'users.read', 'users.write', 'users.delete',
    'astrologers.read', 'astrologers.write', 'astrologers.kyc',
    'shop.read', 'shop.write', 'shop.delete',
    'reports.revenue', 'reports.gst', 'reports.tds',
    'settings.read', 'settings.write',
    'support.read', 'support.write',
    'finance.commissions', 'finance.payouts',
    'system.admin',
  ],
  admin: [
    'users.read', 'users.write', 'users.delete',
    'astrologers.read', 'astrologers.write', 'astrologers.kyc',
    'shop.read', 'shop.write', 'shop.delete',
    'reports.revenue', 'reports.gst', 'reports.tds',
    'settings.read', 'settings.write',
    'support.read', 'support.write',
    'finance.commissions', 'finance.payouts',
  ],
  support: [
    'users.read',
    'astrologers.read',
    'support.read', 'support.write',
  ],
  finance: [
    'reports.revenue', 'reports.gst', 'reports.tds',
    'finance.commissions', 'finance.payouts',
  ],
  content: [
    'shop.read', 'shop.write', 'shop.delete',
    'astrologers.read',
  ],
};

export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};

export const KYC_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const STREAM_STATUS = {
  LIVE: 'live',
  ENDED: 'ended',
  SCHEDULED: 'scheduled',
};

export const CURRENCIES = [
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
];
